export default __webpack_public_path__ + "static/logo-inline-white-ee41e9d74af5b5999d97f0c8f990e674.svg";